import { usePage } from '@inertiajs/react';

/**
 * Lookup a translation by dot-notation key (e.g. 'nav.campaigns'),
 * with optional :placeholder substitution.
 *
 * Catalog is shared from Laravel via HandleInertiaRequests as
 * `i18n.catalog` — a flat map of "namespace.key" => "value".
 * Missing keys fall back to the provided default or the key itself.
 *
 *   const { t } = useT();
 *   t('campaigns.new');
 *   t('greeting', 'Hello :name', { name: 'Ada' });
 */
export function useT() {
    const i18n = usePage().props.i18n ?? {};
    const catalog = i18n.catalog ?? {};
    const locale = i18n.locale ?? 'en';
    const rtl = !! i18n.rtl;

    const t = (key, fallback, replacements) => {
        // Try the key as-is first (e.g. "admin.flash.x" or "common.save"),
        // then try the legacy `app.<key>` shape so older calls keep working.
        let resolved = catalog[key] ?? catalog[`app.${key}`];

        if (! resolved || resolved === '') {
            resolved = fallback ?? key;
        }

        if (replacements && typeof resolved === 'string') {
            for (const [k, v] of Object.entries(replacements)) {
                resolved = resolved.replaceAll(`:${k}`, String(v));
            }
        }

        return resolved;
    };

    return { t, locale, rtl, available: i18n.available ?? [] };
}
